import { apiSlice } from "./../apiSlice";

export const billingAddressApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBillingAddressByUserId: builder.query({
      query: ({ id, token }) => ({
        url: `api/billing/addresses/list/${id}/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    addBillingAddress: builder.mutation({
      query: ({data, token}) => ({
        url: `api/billing/addresses/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    deleteBillingAddress: builder.mutation({
      query: ({ data,token}) => ({
        url: `api/billing/delete-billing-address/${data}`,
        method: "DELETE",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    getBillingAddressByBillingId: builder.query({
      query: ({id, token}) => ({
        url: `api/billing/addresses/${id}/`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    updateBillingAddressByBillingId: builder.mutation({
      query: ({data, token}) => ({
        url: `api/billing/addresses/${data?.billing_add_ID}/`,
        method: "PUT",
        body: data,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    updatePrimaryBillingAddressByBillingId: builder.mutation({
      query: ({ data, id, token }) => ({
        url: `api/billing/primary-addresess/list/${id}/set_primary/`,
        method: "PUT",
        body: data,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),

    cancelSubscription: builder.mutation({
      query: (stripe_subscription_id) => ({
        url: `api/billing/cancel/subscription/${stripe_subscription_id}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    sendMailSubscription: builder.mutation({
      query: ({ mail, stripeSubId }) => ({
        url: `api/billing/send-subscription-mail/${mail}/${stripeSubId}`,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
    checkPaymentStatus: builder.mutation({
      query: ({data, token}) => ({
        url: `api/billing/stripe-status/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
        },
      }),
    }),

    // TIP-464 — opens a Stripe Customer Portal session for the logged-in
    // user's Verified subscription. Frontend opens the returned URL in a
    // new tab; user manages card / views invoices / cancels there.
    /* TIP-662 — post-payment provisioning state for one company.
     *
     * The membership is provisioned asynchronously, from the Stripe webhook,
     * so the buyer can land back on My Businesses before the data says they
     * are a member. This is the read the landing page polls until it does.
     * Keyed on the company rather than the checkout session: the endpoint
     * resolves by company_id, which is why the return URL carries it. */
    getVerifiedPaymentState: builder.query({
      query: ({ companyId }) => ({
        url: `api/billing/verified-payment-state/?company_id=${encodeURIComponent(companyId)}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      }),
      /* Never cached: the whole point is to see a value that is changing
         underneath us, and a cached first answer would be the stale one. */
      keepUnusedDataFor: 0,
    }),

    createVerifiedCustomerPortalSession: builder.mutation({
      query: (token) => ({
        url: `api/billing/verified-customer-portal/`,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useGetBillingAddressByUserIdQuery,
  useAddBillingAddressMutation,
  useUpdateBillingAddressByBillingIdMutation,
  useUpdatePrimaryBillingAddressByBillingIdMutation,
  useCancelSubscriptionMutation,
  useSendMailSubscriptionMutation,
  useDeleteBillingAddressMutation,
  useGetBillingAddressByBillingIdQuery,
  useCheckPaymentStatusMutation,
  useCreateVerifiedCustomerPortalSessionMutation,
  useGetVerifiedPaymentStateQuery,
} = billingAddressApiSlice;
